import { type Quiz } from '../defs/quiz';

export interface FunnelFavoritePairing {
  pairingId: number;
  name: string;
}

/**
 * Derive the pairings to favorite on signup from the funnel swipe deck:
 * a positive swipe on a pairing mirrors the 242
 * post-checkout deck's heart, which both rates and favorites the pairing.
 * Products never become favorites (the endpoint is pairings-only), and
 * negative/skip ratings are excluded. Deduped by `pairingId` in case the
 * same pairing was swiped more than once across meals.
 */
export function deriveFunnelFavoritePairings(
  quiz: Quiz
): FunnelFavoritePairing[] {
  const seen = new Set<number>();
  const favorites: FunnelFavoritePairing[] = [];

  for (const entry of quiz.swipeRatings ?? []) {
    if (entry.rating !== 'positive' || entry.itemType !== 'pairing') {
      continue;
    }
    if (seen.has(entry.itemId)) {
      continue;
    }
    seen.add(entry.itemId);
    favorites.push({ pairingId: entry.itemId, name: entry.name ?? '' });
  }

  return favorites;
}
